import type { CalendarEarning } from '~/types/earningsCalendar.types';

export function tickerLogoUrl(item: CalendarEarning): string {
  return item.logoUrl || `https://images.financialmodelingprep.com/symbol/${item.symbol}.png`;
}
